<template>
  <v-container fluid mb-5 class="black-cont">
    <v-layout justify-center ma-1>
      <v-flex md9 align-self-center>
        <v-card color="grey darken-2" dark>
          <v-card-title primary-title>
            <h1 class="headline mb-0">Experience</h1>
          </v-card-title>
          <v-card-text>
            <ResumeExperience></ResumeExperience>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center ma-1>
      <v-flex md9>
        <v-card color="grey darken-2" dark>
          <v-card-title primary-title>
            <h1 class="headline mb-0">Education</h1>
          </v-card-title>
          <v-card-text>
            <ResumeEducation></ResumeEducation>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center ma-1>
      <v-flex md9>
        <v-card color="grey darken-2" dark>
          <v-card-title primary-title>
            <h1 class="headline mb-0">Skills</h1>
          </v-card-title>
          <v-card-text>
            <ResumeSkills></ResumeSkills>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ResumeExperience from "@/components/ResumeExperience.vue";
import ResumeEducation from "@/components/ResumeEducation.vue"; 
import ResumeSkills from "@/components/ResumeSkills.vue";

export default {
  name: "resume",
  components: {
    ResumeExperience,
    ResumeEducation,
    ResumeSkills
  },
  data() {
    return {
      items: [
        {
          title: "Experience",
          content: "<ResumeExperience></ResumeExperience>"
        },
        {
          title: "Education",
          content: "<ResumeEducation></ResumeEducation>"
        },
        {
          title: "Skills",
          content: "<ResumeSkills></ResumeSkills>"
        }
      ]
    };
  }
};
</script>
